<form [formGroup]="staffRNDForm">
  <div class="main-box">
    <!-- <div class="header-box d-flex flex-wrap w-100">
      <h2 class="ms-4">
        <span>{{ commonLabelConstants.Forms }} &nbsp;</span> /
        {{ labelConstants.StaffingCostHeader }}
        <span mb-2 [ngClass]="{ 'locked-text ms-2 text-danger': isLocked }">{{
          +isLocked ? commonLabelConstants.Locked : ""
        }}</span>
      </h2>
    </div> -->
    <!-- <div class="form-heading">
      <h3>{{ labelConstants.StaffingCostHeader }}
        </h3>
    </div> -->
    <div class="d-flex p-2 float-end sticky-button">
      <button (click)="exportList()" type="button" class="btn btn-primary-datalist ms-3" *ngIf="employee.controls.length != 0">
        <i class="fa-solid fa-download"></i>
        <span class="hidebuttonName"> EXPORT</span>
      </button>
    </div>
    <app-loader [count]="10" [appearance]="'line'" [isLoading]="isLoading">
      <div class="claim-table">
        <div class="table-container">
          <div class="table-responsive table-height">
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th class="equal-width-col">{{ labelConstants.EmployeeName }}</th>
                  <th class="equal-width-col">{{ labelConstants.JobRole }}</th>
                  <th class="equal-width-col">{{ labelConstants.EligibleCost }}</th>
                  <th *ngFor="let item of projectList" class="equal-width-col">
                    {{ item.projectName }}
                  </th>
                  <th class="equal-width-col">{{ labelConstants.Cost }}</th>
                </tr>
              </thead>

              <tbody class="table-height">
                <ng-container formArrayName="employee">
                  <tr *ngFor="let item of employee.controls; let i = index" [formGroupName]="i">
                    <td class="equal-width-col">
                      <span>{{ item.get("employeeName")?.value }}</span>
                    </td>

                    <td class="equal-width-col">
                      <span>{{ item.get("employeeJobRole")?.value }}</span>
                    </td>

                    <td>
                      <span class="equal-width-col">{{
                        item.get("totalGross")?.value
                        | customCurrency : env.CurrencyFormat
                        }}</span>
                    </td>

                    <ng-container formArrayName="project">
                      <td class="equal-width-col" *ngFor="
                            let itemDetails of getProjectDetails(i).controls;
                            let j = index
                          " [formGroupName]="j">
                        <span>{{
                          itemDetails.get("rndEligibility")?.value
                          | customPercentage : env.CurrencyFormat
                          }}</span>
                      </td>
                    </ng-container>

                    <td>
                      <span>{{
                        item.get("totalEligibilityPer")?.value
                        | customCurrency : env.CurrencyFormat
                        }}</span>
                    </td>
                  </tr>
                </ng-container>
              </tbody>
              <tfoot *ngIf="
                    employee.controls && employee.controls.length > 0;
                    else noRecords
                  ">
                <tr>
                  <td colspan="2">
                    <b>{{ labelConstants.Staffing }} (£)</b>
                  </td>
                  <td class="equal-width-col">
                    <span><b>{{
                        getCostTotal() | customCurrency : env.CurrencyFormat
                        }}</b></span>
                  </td>
                  <td *ngFor="let item of projectList; let projectIndex = index" class="equal-width-col">
                    <span><b>{{ getTotalProduct(projectIndex)  }}</b></span>
                  </td>
                  <td>
                    <span><b>{{
                        getTotalQualifyingCosts()
                        | customCurrency : env.CurrencyFormat
                        }}</b></span>
                  </td>
                </tr>
              </tfoot>
              <ng-template #noRecords>
                <tfoot>
                  <tr>
                    <td [colSpan]="4 + projectList.length" class="text-center">
                      {{ commonLabelConstants.NoReacordFound }}
                    </td>
                  </tr>
                </tfoot>
              </ng-template>
            </table>
          </div>
        </div>
      </div>
    </app-loader>
  </div>
</form>
